import * as DOM from './utils';

export default function addDisplayLayerGetFeatureInfo(leaflet) {
    const IconOptions = leaflet.Icon.extend({
        options: {
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        },
    });

    // Icon based on: "https://www.flaticon.com/authors/elegant-themes" "https://www.flaticon.com/" "http://creativecommons.org/licenses/by/3.0/"
    const icon = new IconOptions({ iconUrl: './static/markers/marker.svg' });

    let tip = false;
    let request = false;

    this.map.on('click', (e) => {
        if (tip) { tip.closeTooltip(); this.map.removeLayer(tip); tip = false; }
        const { selectedDisplayLayer } = this.state;
        const { latlng } = e;
        const { lat, lng } = latlng;
        this.state.lastClick = latlng;

        const systems = (selectedDisplayLayer.systems) ? selectedDisplayLayer.systems.toString() : 'GSM,UMTS,LTE,NR';
        const url = `${this.config.connections.feature}layers=${selectedDisplayLayer.query}&bbox=${lng},${lat},${lng},${lat}&layerType=MapTiles&systems=${systems}&usages=${selectedDisplayLayer.usage}`;

        if (request) { request.abort(); }
        request = DOM.get(url, (requestError, response) => {
            if (requestError) {
                if (response.type === 'abort') { return; } console.error(response); return;
            }
            request = false;
            try {
                const data = JSON.parse(response);

                let string = 'Ingen info';

                if (data.length === 1) { string = `${data[0]}`; }
                if (data.length === 2) { string = `${data[0]}</br>${data[1]}`; }
                if (data.length === 3) { string = `${data[0]}</br>${data[1]}</br>${data[2]}`; }
                if (data.length === 4) { string = `${data[0]}</br>${data[1]}</br>${data[2]}</br>${data[3]}`; }

                string = string.replace(/"/g, '');

                tip = leaflet.marker(latlng, { icon });
                tip.bindTooltip(string, {
                    permanent: true,
                    offset: leaflet.point(0, -20),
                }).openTooltip();
                tip.addTo(this.map);
            } catch (parseError) {
                console.error(parseError);
            }
        });
    });
}
